import { lazy, Suspense } from "react";
import HeroSection from "@/components/HeroSection";
import AIAdvantageSection from "@/components/AIAdvantageSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import GuaranteeSection from "@/components/GuaranteeSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import WebsiteTypesSection from "@/components/WebsiteTypesSection";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import AnimateOnScroll from "@/components/AnimateOnScroll";
import ScrollToTop from "@/components/ScrollToTop";
import StickyCTA from "@/components/StickyCTA";

const ShowcaseSection = lazy(() => import("@/components/ShowcaseSection"));
const PricingSection = lazy(() => import("@/components/PricingSection"));
const ContactSection = lazy(() => import("@/components/ContactSection"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <AnimateOnScroll variant="zoom">
        <HeroSection />
      </AnimateOnScroll>
      <AnimateOnScroll variant="zoom">
        <WebsiteTypesSection />
      </AnimateOnScroll>
      <AnimateOnScroll variant="zoom">
        <AIAdvantageSection />
      </AnimateOnScroll>
      <Suspense fallback={<div className="min-h-[400px]" />}>
        <AnimateOnScroll variant="zoom">
          <ShowcaseSection />
        </AnimateOnScroll>
      </Suspense>
      <AnimateOnScroll variant="zoom">
        <TestimonialsSection />
      </AnimateOnScroll>
      <AnimateOnScroll variant="zoom">
        <HowItWorksSection />
      </AnimateOnScroll>
      <Suspense fallback={<div className="min-h-[400px]" />}>
        <AnimateOnScroll variant="zoom">
          <PricingSection />
        </AnimateOnScroll>
      </Suspense>
      <AnimateOnScroll variant="zoom">
        <GuaranteeSection />
      </AnimateOnScroll>
      <AnimateOnScroll variant="zoom">
        <FAQSection />
      </AnimateOnScroll>
      <Suspense fallback={<div className="min-h-[400px]" />}>
        <AnimateOnScroll variant="zoom">
          <ContactSection />
        </AnimateOnScroll>
      </Suspense>
      <Footer />
      <ScrollToTop />
      <StickyCTA />
    </div>
  );
};

export default Index;
